export default __webpack_public_path__ + "assets/c59d7e57ecc2c77d3abaef7efc48bf5b.jpg";